import React, { useState, useEffect } from 'react';

import { BuildPath } from  '@/helpers/Paths';

import  '@/css/filterHeader.scss';

interface FilterHeader {
    columnNames: string[],
    disabledColumns?: string[],
    setFilter:({sortBy,sort}: {sortBy: string, sort:  string }) => any,
    currentFilters: {sortBy?: string, sort?: string}
}

interface IFilterHeaderItem  {
    name: string,
    activeFilter?: {filterName: string, filterDirection: string},
    isDisabled?: boolean,
    handleFilterClick?: () => void,
    isCurrentFilter: boolean


}

function FilterHeaderItem({name, activeFilter, isDisabled, handleFilterClick, isCurrentFilter}: IFilterHeaderItem): JSX.Element {

    return (
        <th
            scope="col"
            aria-sort={
                isCurrentFilter
                    ? activeFilter?.filterDirection === "asc"
                        ? "ascending"
                        : "descending"
                    : "none"
            }
        >
            <button
                type="button"
                className="filter-header-heading"
                onClick={handleFilterClick}
                disabled={isDisabled}
                aria-label={`${name} column sort`}
            >
                {name}
                {isCurrentFilter ? (
                    <img
                        src={`${BuildPath()}/images/insightsp2/decend.svg`}
                        alt=""
                        aria-hidden="true"
                        className={activeFilter?.filterDirection}
                    />
                ) : (
                    <span className="filter-placeholder" aria-hidden="true">
                &nbsp;
            </span>
                )}
            </button>
        </th>
    );
}

const FilterHeader = ({columnNames, setFilter, currentFilters, disabledColumns}: FilterHeader ) => {
    const [activeFilter, setActiveFilter] = useState<{filterName: string, filterDirection: string}>(getActiveFilter());

    const { filterName, filterDirection } = activeFilter;
    
    useEffect(() => {
        if (filterName && filterDirection) {
            setFilter({sortBy: filterName, sort: filterDirection})
        }  
    }, [filterName, filterDirection])

    function getActiveFilter() {
        if (currentFilters.sortBy &&  currentFilters.sort) {
            return {filterName: currentFilters.sortBy,  filterDirection: currentFilters.sort}
        }
        return {filterName: columnNames[1], filterDirection: 'desc'}
    }

    function isDisabled(name: any): boolean {
        return (disabledColumns && disabledColumns.includes(name)) ?? false
    }

    function handleFilterClick(isCurrentFilter: boolean, name: string) {
        let newFilter;
        if (isDisabled(name)) {
            return;
        }
        if (!isCurrentFilter)  {
            newFilter = 'desc'
        }
        if (isCurrentFilter) {
            newFilter = activeFilter.filterDirection === 'desc' ? 'asc' : 'desc' 
        }
        setActiveFilter({
            filterName: name,
            filterDirection: newFilter
        });
    }



    return (
        <>
        {columnNames.map(col => 
           <FilterHeaderItem
                key={col}
                name={col}
                activeFilter={activeFilter}
                isDisabled={isDisabled(col)}
                handleFilterClick={() => handleFilterClick(activeFilter && activeFilter.filterName === col, col)}
                isCurrentFilter = {activeFilter && activeFilter.filterName === col}
           />
        )}
        </>
    )
}

export default FilterHeader